import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";

interface Props {
  className: string;
  onClick: () => void;
  disabled: boolean;
  buttonHeight?: number;
}

const AddToModelButton: React.FC<Props> = ({
  className,
  onClick,
  disabled,
  buttonHeight = 40,
}) => {
  return (
    <Button
      className={className}
      text="Add to Model"
      onClick={onClick}
      disabled={disabled}
      variant="contained"
      buttonType="primary"
      style={{ whiteSpace: "nowrap" }}
      sx={{ width: "134px", height: `${buttonHeight}px`, marginLeft: "16px" }}
    />
  );
};

export default AddToModelButton;
